import { useEffect, useState } from "react";
import API from "../config/api.js";

export default function EmailPrompt({ onSaved }) {
  const [open, setOpen]       = useState(false);
  const [saving, setSaving]   = useState(false);
  const [idemail, setIdemail] = useState("");
  const [title, setTitle]     = useState("");
  const [content, setContent] = useState("");

  // ── Expose window._email_edit ─────────────────────────────────────────────
  useEffect(() => {
    window._email_edit = (id, emailTitle, emailContent) => {
      setIdemail(id || "");
      setTitle(emailTitle || "");
      setContent(emailContent || "");
      setOpen(true);
    };
    return () => { delete window._email_edit; };
  }, []);

  const handleClose = () => {
    setOpen(false);
    setIdemail("");
    setTitle("");
    setContent("");
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const fd = new FormData();
      fd.append("idemail", idemail);
      fd.append("title",   title);
      fd.append("content", content);

      await fetch(`${API.emails}?save`, {
        method: "POST", credentials: "include", body: fd,
      });

      window._alert?.("success", "Email draft saved");
      handleClose();
      onSaved?.();
    } catch (err) {
      console.error("EmailEditor save:", err);
    } finally {
      setSaving(false);
    }
  };

  const handleAssistant = () => {
    window._assistant_text_add?.(content);
    handleClose();
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content);
      window._alert?.("success", "Copied to clipboard");
    } catch (_) {}
  };

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1040 }} onClick={handleClose} />
      <div
        className="modal fade show d-block"
        tabIndex={-1}
        style={{ zIndex: 1050 }}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content rounded-4">
            <form onSubmit={handleSave}>
              <div className="modal-body">
                {/* Desktop close */}
                <button
                  type="button"
                  className="d-none d-sm-block btn btn-close bg-white rounded-circle p-3 position-absolute"
                  style={{ right: -55, height: 22, marginTop: -15 }}
                  onClick={handleClose}
                  aria-label="Close"
                />
                {/* Mobile close */}
                <button
                  type="button"
                  className="d-block d-sm-none btn btn-close bg-white rounded-circle p-3 position-absolute end-0"
                  style={{ zIndex: 1000 }}
                  onClick={handleClose}
                  aria-label="Close"
                />

                <input type="hidden" value={idemail} readOnly />

                <label className="fw-bold py-2 text-dark">Subject</label>
                <input
                  name="title"
                  type="text"
                  className="form-control mb-3"
                  placeholder="Subject"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  required
                />

                <label className="fw-bold mb-2">Content</label>
                <textarea
                  name="content"
                  className="form-control"
                  rows={20}
                  placeholder="Email"
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                  required
                />
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleAssistant}>
                  <i className="fi fi-rr-bulb" />
                </button>
                <button type="button" className="btn btn-secondary" onClick={handleCopy}>
                  <i className="fi fi-rr-duplicate" />
                </button>
                <button type="submit" className="btn btn-primary" disabled={saving}>
                  {saving ? "Saving..." : "Save Email Draft"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}